"use client";

import React, { useState } from 'react';

interface Faq {
    question: string;
    answer: string;
}

interface Props {
    faqs: Faq[];
}

const INITIAL_VISIBLE = 8; // 4 left + 4 right

const FaqAccordion = ({ faqs }: Props) => {
    const [showAll, setShowAll] = useState(false);

    const visibleFaqs = showAll ? faqs : faqs.slice(0, INITIAL_VISIBLE);
    const hasMore = faqs.length > INITIAL_VISIBLE;

    return (
        <>
            {/* FAQ accordion — 2 columns on desktop */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
                {visibleFaqs.map((faq, index) => (
                    <details
                        key={index}
                        className="group bg-white border border-gray-200 rounded-xl overflow-hidden transition-all duration-300 hover:border-[#5D27A1]/40 hover:shadow-sm"
                    >
                        <summary className="list-none [&::-webkit-details-marker]:hidden flex justify-between items-center p-4 cursor-pointer select-none gap-3">
                            <span className="font-medium text-sm leading-snug text-gray-700 group-open:text-[#5D27A1] transition-colors duration-200">
                                {faq.question}
                            </span>
                            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center transition-all duration-300 group-open:bg-[#5D27A1] group-open:rotate-180">
                                <svg className="w-3.5 h-3.5 text-gray-500 group-open:text-white transition-colors duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" />
                                </svg>
                            </div>
                        </summary>
                        <div className="px-4 pb-4 text-sm leading-relaxed text-gray-600 border-t border-gray-100">
                            <div className="pt-3" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                        </div>
                    </details>
                ))}
            </div>

            {/* Show More / Show Less button */}
            {hasMore && (
                <div className="flex justify-center mt-8">
                    <button
                        onClick={() => setShowAll(prev => !prev)}
                        className="inline-flex items-center gap-2 px-6 py-3 rounded-xl border border-[#5D27A1]/30 bg-white text-[#5D27A1] text-sm font-semibold transition-all duration-300 hover:bg-[#5D27A1] hover:text-white hover:border-[#5D27A1] hover:shadow-md active:scale-95"
                    >
                        {showAll ? (
                            <>
                                Show Less
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
                                </svg>
                            </>
                        ) : (
                            <>
                                Show More
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                </svg>
                            </>
                        )}
                    </button>
                </div>
            )}
        </>
    );
};

export default FaqAccordion;
